import React from "react";
import { NewHeader } from "../../components/header/NewHeader";
import { NewFooter } from "../../components/footer/NewFooter";
import { GenericPictureTitle } from "../../components/header/GenericPictureTitle";
import { PrivacyTextBlock } from "./PrivacyText";
import { LinksBlock } from "../../components/footer/LinksBlock";

export function PrivacyPolicyPage() {
	return (
		<>
			{/* header-area */}
			<NewHeader></NewHeader>

			<GenericPictureTitle TitleName="PRIVACY POLICY"></GenericPictureTitle>
			<PrivacyTextBlock></PrivacyTextBlock>
			<LinksBlock></LinksBlock>
			<NewFooter></NewFooter>
		</>
	);
}
